import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NgxPermissionsObject, NgxPermissionsService } from 'ngx-permissions';
import { PatientusRole } from '../../../auth/auth.roles';
import { AppState, MediaStreamElement } from '../../../media/store/media.state';
import { TokenService } from '../../../conference-v2/providers/token.service';

@Component({
    selector: 'app-dashboard-layout',
    templateUrl: './dashboard-layout.component.html',
    styleUrls: ['./dashboard-layout.component.scss']
})
export class DashboardLayoutComponent implements OnInit {
    roles$: Observable<NgxPermissionsObject>;
    remoteStream$: Observable<MediaStreamElement>;
    PATIENT: string = PatientusRole.PATIENT;

    constructor(
        private permissionService: NgxPermissionsService,
        private tokenService: TokenService,
        private store: Store<AppState>,
    ) {
    }

    public ngOnInit(): void {
        this.roles$ = this.permissionService.permissions$;
        this.remoteStream$ = this.store.select(state => state.media.remoteStream).pipe(filter(e => !!e));
    }
}
